import "./ProviderListingCard_module.css";
import AppointmentButton from '../appointments/AppointmentButton';
import { useEffect, useCallback, useState, useMemo } from "react";
import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { useDispatch, useSelector, shallowEqual } from "react-redux";
import Years_Of_Experience from "../../assets/images/icon/Vector.png";
import Events_performed from "../../assets/images/icon/star.png";
import Ratings_Reviews from "../../assets/images/icon/Vector.png";
import user_avatar from "../../assets/images/icon/User Avatar 1.png";
import veglog from "../../assets/images/icon/veg.png";
import poojari from "../../assets/images/poojari.webp";
import {
  addToCart,
  removeFromCart,
  removeTenthouseByEventId,
  isProviderAdded,
  checkisProviderAdded,
  getCartId,
  selectCartData,
  triggerRefresh,
  removePreistByEventId,
  getTenthouseProviderID,
  isServiceCheckedOut,
  getCateringItemsByEventId,
} from "../../store/cartSlice";
import {
  getPriestToCartAPI,
  addPriestToCartAPI,
  deletePriestFromCartAPI,
  addTentToCartAPI,
  deleteTentCartItemAPI,
  addCateringToCartAPI,
  deleteCateringCartItemAPI,
  addPriestPackageToCartAPI,
} from "../../Apiservices/Auth/cart/Addtocart_api";

import AddToCartButton from "./addtocartbutton";
import React from "react";
import LoadMap from "../EventServices/LoadMap";
import LocationOnOutlinedIcon from "@mui/icons-material/LocationOnOutlined";
import RouteOutlinedIcon from "@mui/icons-material/RouteOutlined";
import PhoneAndroidOutlinedIcon from "@mui/icons-material/PhoneAndroidOutlined";
import EmailOutlinedIcon from "@mui/icons-material/EmailOutlined";
import StarIcon from "@mui/icons-material/Star";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import CircleIcon from "@mui/icons-material/Circle";
import SquareFootIcon from "@mui/icons-material/SquareFoot";
import PeopleIcon from "@mui/icons-material/People";
import RestaurantIcon from "@mui/icons-material/Restaurant";
import LocalBarIcon from "@mui/icons-material/LocalBar";
import FastfoodIcon from "@mui/icons-material/Fastfood";
import TimerIcon from "@mui/icons-material/Timer";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import RadioButtonUncheckedIcon from "@mui/icons-material/RadioButtonUnchecked";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import "primeflex/primeflex.css";
import debuglog from "../../util/helperutil";
import { useNavigate } from "react-router-dom";
import { removePriestByCartId } from "../../store/cartbodydataslice";
import { usePriestCart } from "../../hooks/usePriestCart";
import { useTentCart } from "../../hooks/useTentCart";
import { useCateringCart } from "../../hooks/usecateringcart";
import PackageOverlay from "./PackageOverlay";
import MenuDialog from "../MenuDialog";
import config from "../../config";

function ProviderListingCard({
  quantity,
  serviceId,
  services,
  providerid,
  appointmentProviderId,
  event,
  key,
  latitude,
  longitude,
  name,
  address,
  distance,
  mobile,
  email,
  packages,
  price: originalPrice,
  discount: originalDiscount,
  validUpto: originalvalidUpto,
  // Venue specific props
  rating = 4.5,
  providerFirstName = "",
  providerLastName = "",
  shortAddress = "",
  distanceInMeter = 0,
  primaryImage = null,
  rules = [],
  sections = [],
  expectedGuestCount = null,
  selectedSpaceId = null,
  eventStartDate = null,
  eventEndDate = null,
  rsvpGuestCount = null,
  onSpaceSelected = null,
  onBookNow = null,
}) {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const eventID = event.id || NaN;
  const service_id = event.eventId || NaN;
  const eventname = event.eventTitle || NaN;
  const { priestCartLoading, refreshPriestCart, removePriestCartItem } =
    usePriestCart();
  const { tentCartLoading, refreshTentCart, removeTentProvider, editbutton } =
    useTentCart();
  const { refreshCateringCart, removeCateringProvider } = useCateringCart();

  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const [selectedMenu, setSelectedMenu] = useState(null);

  const [showPackageInfo, setShowPackageInfo] = useState(false);
  const [expandedSpaces, setExpandedSpaces] = useState({});

  // Toggle space expansion
  const toggleSpaceExpansion = (spaceId) => {
    setExpandedSpaces(prev => ({
      ...prev,
      [spaceId]: !prev[spaceId]
    }));
  };

  // Helper function to check if discount is valid
  const hasValidDiscount = (option) => {
    const now = new Date();
    return option?.discountValidUpto &&
      option?.discountPrice &&
      option.discountPrice > 0 &&
      new Date(option.discountValidUpto) > now;
  };

  // Helper function to get display price
  const getDisplayPrice = (option) => {
    if (hasValidDiscount(option)) {
      return option.discountPrice;
    }
    return option?.price || 0;
  };

  // Helper function to get starting price from pricing options
  const getStartingPrice = (pricingOptions) => {
    if (!pricingOptions || pricingOptions.length === 0) return 0;
    let lowestPrice = Infinity;
    pricingOptions.forEach(option => {
      const price = getDisplayPrice(option);
      if (price < lowestPrice) {
        lowestPrice = price;
      }
    });
    return lowestPrice !== Infinity ? lowestPrice : 0;
  };

  console.log("checpackage", services);

  const alreadyAdded = useSelector((state) =>
    serviceId == 9
      ? isProviderAdded(
        state,
        eventID,
        providerid,
        serviceId,
        services.itemId
      )
      : isProviderAdded(state, eventID, providerid, serviceId)
  );
  const isChecked = useSelector((state) =>
    serviceId == 9
      ? isServiceCheckedOut(
        state,
        eventID,
        providerid,
        parseInt(serviceId),
        services.itemId
      )
      : isServiceCheckedOut(state, eventID, parseInt(serviceId))
  );

  const Itemnames_withquantity = useMemo(() => {
    if (Number(serviceId) !== 8) return null;
    if (!Array.isArray(quantity) || !Array.isArray(services)) return [];
    return quantity
      .map((q) => {
        const match = services.find((s) => s.serviceId === q.id);
        if (!match) return null;
        return { itemName: match.serviceName, quantity: q.count };
      })
      .filter(Boolean);
  }, [serviceId, quantity, services]);

  const { main: catering_main, sides: catering_sides } = useMemo(() => {
    if (Number(serviceId) !== 9) {
      return { main: [], sides: [] };
    }
    const rawItems = services?.includedItems || [];
    const normalized = rawItems.map((item) => ({
      itemName: item.itemName || item.item_name || "Catering Item",
      qty: item.qty || item.quantity || 1,
    }));
    return {
      main: normalized,
      sides: [],
    };
  }, [serviceId, services?.includedItems]);

  const includedItemsInfo = useMemo(() => {
    if (Number(serviceId) !== 9) return null;
    const items = services?.includedItems ?? null;
    return formatIncludedItems(items, { maxVisible: 6 });
  }, [serviceId, services]);

  const [addnewcaterer, setaddnewcaterer] = useState(false);
  const checkalreadyAdded = useSelector((state) =>
    serviceId === 9
      ? checkisProviderAdded(
        state,
        eventID,
        providerid,
        serviceId,
        services.itemId
      )
      : checkisProviderAdded(state, eventID, providerid, serviceId)
  );

  const cartId = useSelector((state) => getCartId(state, eventID, serviceId));

  const addedproviderID = useSelector((state) =>
    getTenthouseProviderID(state, eventID)
  );

  const calculateTotalPrices = (quantityList, services) => {
    const currentDate = new Date();
    return services.reduce(
      (acc, item) => {
        const regular = parseFloat(item.price);
        const discount = parseFloat(item.discountPrice);
        const validUpto = new Date(item.discountValidUpto);
        const match = quantityList.find((q) => q.id === item.serviceId);
        const itemQuantity = match ? match.count : 0;
        acc.totalPrice += isNaN(regular) ? 0 : regular * itemQuantity;
        if (!isNaN(discount) && discount > 0 && currentDate < validUpto) {
          acc.totalDiscountPrice += discount * itemQuantity;
          acc.validDates.push(validUpto);
        } else {
          acc.totalDiscountPrice += regular * itemQuantity;
        }
        return acc;
      },
      {
        totalPrice: 0,
        totalDiscountPrice: 0,
        validDates: [],
      }
    );
  };

  let price = originalPrice;
  let discount = originalDiscount;
  let validUpto = originalvalidUpto;

  const handleSeeMore = useCallback((menuType, items) => {
    console.log("Opening dialog with items:", items?.length);
    setSelectedMenu({
      label: menuType,
      items: items,
    });
    setIsDialogOpen(true);
  }, []);

  const handleCloseDialog = useCallback(() => {
    console.log("Closing dialog");
    setIsDialogOpen(false);
    setSelectedMenu(null);
  }, []);

  if (serviceId == 8) {
    const { totalDiscountPrice, totalPrice, validDates } = calculateTotalPrices(
      quantity,
      services
    );
    price = totalPrice ?? originalPrice;
    discount = totalDiscountPrice ?? originalDiscount;
    validUpto = validDates.length > 0 ? validDates[0] : originalvalidUpto;
  }

  const getValuesFromDate = (services) => {
    const currentDate = new Date();
    const result = {
      totalPrice: 0,
      totalDiscountPrice: 0,
      validDates: [],
    };
    if (!services || services.length === 0) {
      return result;
    }
    const item = services;
    const regular = parseFloat(item.regularPrice);
    const discount = parseFloat(item.discountedPrice);
    const validUpto = new Date(item.discountValidUpto);
    const isRegularValid = !isNaN(regular);
    const isDiscountValid =
      !isNaN(discount) && discount > 0 && currentDate < validUpto;
    if (isRegularValid) {
      result.totalPrice = regular;
      if (isDiscountValid) {
        result.totalDiscountPrice = discount;
        result.validDates.push(validUpto);
      } else {
        result.totalDiscountPrice = regular;
      }
    }
    return result;
  };

  const [selectedServiceId, setSelectedServiceId] = useState(null);
  if (serviceId == 9) {
    const { totalPrice, totalDiscountPrice, validDates } =
      getValuesFromDate(services);
    price = totalPrice ?? originalPrice;
    discount = totalDiscountPrice ?? originalDiscount;
    validUpto = validDates.length > 0 ? validDates : originalvalidUpto;
  }

  const handleAddPackageToCart = async (packageSelection) => {
    console.log("Adding package to cart:", packageSelection);
    const { packageId, packageData } = packageSelection;
    if (checkalreadyAdded && !isChecked) {
      setAlertMessage(true);
      setPackageToAdd(packageSelection);
      return;
    } else if (isChecked) {
      setpaidcheckdialog(true);
      return;
    }
    await addPackageToCart(packageId, packageData);
  };

  const [packagePriceInfo, setPackagePriceInfo] = useState({
    hasPackages: false,
    availableForCurrentEvent: false,
    selectedPackagePrice: null,
    selectedPackageDiscountPrice: null,
    selectedPackageValidTill: null,
  });

  useEffect(() => {
    if (Number(serviceId) !== 7) return;
    console.log("checpackage", packages);
    const hasPackages = packages && Array.isArray(packages) && packages.length > 0;
    let availableForCurrentEvent = false;
    let relevantPackages = [];
    if (hasPackages) {
      relevantPackages = packages.filter((pkg) => {
        if (
          !pkg.recommendedEvents ||
          !Array.isArray(pkg.recommendedEvents) ||
          pkg.recommendedEvents.length === 0
        ) {
          return true;
        }
        return pkg.recommendedEvents.some((event) => {
          const eventIdMatch = event.eventId === eventID;
          const eventTitleMatch =
            event.eventTitle?.toLowerCase() === eventname?.toLowerCase();
          const eventNameMatch =
            event.eventName?.toLowerCase() === eventname?.toLowerCase();
          return eventIdMatch || eventTitleMatch || eventNameMatch;
        });
      });
      availableForCurrentEvent = relevantPackages.length > 0;
      console.log("Filtered packages for event:", relevantPackages);
      console.log("Available for current event:", availableForCurrentEvent);
    }
    setPackagePriceInfo({
      hasPackages,
      availableForCurrentEvent,
      relevantPackagesCount: relevantPackages.length,
    });
  }, [packages, eventID, eventname, serviceId]);

  let displayPrice = price;
  let displayDiscount = discount;
  let displayValidUpto = validUpto;

  if (Number(serviceId) === 7) {
    if (packagePriceInfo.selectedPackageDiscountPrice) {
      displayPrice = packagePriceInfo.selectedPackagePrice;
      displayDiscount = packagePriceInfo.selectedPackageDiscountPrice;
      displayValidUpto = packagePriceInfo.selectedPackageValidTill;
    }
  }

  const isPackageForEvent = (pkg) => {
    if (
      !pkg.recommendedEvents ||
      !Array.isArray(pkg.recommendedEvents) ||
      pkg.recommendedEvents.length === 0
    ) {
      return true;
    }
    return pkg.recommendedEvents.some((event) => {
      const eventIdMatch = event.eventId === eventID;
      const eventTitleMatch =
        event.eventTitle?.toLowerCase() === eventname?.toLowerCase();
      const eventNameMatch =
        event.eventName?.toLowerCase() === eventname?.toLowerCase();
      return eventIdMatch || eventTitleMatch || eventNameMatch;
    });
  };

  const cartStatepreist = useSelector(
    (state) => state.cart.serviceList.preist[eventID]
  );
  const cartStatecatering = useSelector(
    (state) => state.cart.serviceList.catering[eventID]
  );
  const cartStatetenthouse = useSelector(
    (state) => state.cart.serviceList.tenthouse[eventID]
  );

  useEffect(() => { }, [cartStatepreist, cartStatecatering, cartStatetenthouse]);

  const generateTentCartItems = () => {
    if (!Array.isArray(services) || !Array.isArray(quantity)) return [];
    return services
      .map((service) => {
        const match = quantity.find((q) => q.id === service.serviceId);
        if (match) {
          return {
            tent_house_service_id: service.serviceId,
            mapping_id: service.mappingId,
            quantity: match.count,
          };
        }
        return null;
      })
      .filter((item) => item !== null);
  };

  const [message, setMessage] = useState({ text: "", type: "" });
  const cateringItems = useSelector((state) =>
    getCateringItemsByEventId(state, eventID)
  );

  const handleClick = async () => {
    if (serviceId == 7) {
      try {
        if (checkalreadyAdded) {
          try {
            dispatch(removePreistByEventId({ eventID }));
            removePriestCartItem(cartId, eventID);
            setMessage({
              text: "Existing priest removed. Adding new priest...",
              type: "info",
            });
            const response = await addPriestToCartAPI({
              event_id: eventID,
              priest_id: providerid,
              service_id,
            });
            dispatch(
              addToCart({
                serviceType: "preist",
                eventID,
                providerID: providerid,
                cart_id: cartId,
              })
            );
            console.log("Response from addPriestToCartAPI:", response);
            setMessage({
              text: "Priest successfully replaced in cart",
              type: "success",
            });
            dispatch(triggerRefresh());
          } catch (error) {
            console.error("Error replacing priest:", error);
            setMessage({ text: "Failed to replace priest", type: "error" });
          }
        } else {
          try {
            const response = await addPriestToCartAPI({
              event_id: eventID,
              priest_id: providerid,
              service_id,
            });
            dispatch(
              addToCart({
                serviceType: "preist",
                eventID,
                providerID: providerid,
                cart_id: cartId,
              })
            );
            console.log("Response from addPriestToCartAPI:", response);
            setMessage({
              text: "Priest successfully added to cart",
              type: "success",
            });
            dispatch(triggerRefresh());
          } catch (error) {
            console.error("Error adding priest:", error);
            setMessage({ text: "Failed to add priest", type: "error" });
          }
        }
      } catch (error) {
        console.error("Failed to call addPriestToCartAPI:", error.message);
      }
    }
    if (serviceId == 8) {
      try {
        if (checkalreadyAdded) {
          try {
            removeTentProvider(eventID, addedproviderID);
            dispatch(removeTenthouseByEventId({ eventID }));
            setMessage({
              text: "Existing tenthouse provider removed. Adding new tenthouse...",
              type: "info",
            });
            const tentItems = generateTentCartItems();
            const response = await addTentToCartAPI({
              event_id: eventID,
              tent_provider_id: providerid,
              items: tentItems,
            });
            dispatch(
              addToCart({
                serviceType: "tenthouse",
                eventID: eventID,
                providerID: providerid,
              })
            );
            console.log("Response from addTentToCartAPI:", response);
            setMessage({
              text: "Tenthouse service successfully replaced in cart",
              type: "success",
            });
            dispatch(triggerRefresh());
          } catch (error) {
            console.error("Error replacing tenthouse provider:", error);
            setMessage({
              text: "Failed to replace tenthouse provider",
              type: "error",
            });
          }
        } else {
          const tentItems = generateTentCartItems();
          const response = await addTentToCartAPI({
            event_id: eventID,
            tent_provider_id: providerid,
            items: tentItems,
          });
          console.log("testing eventid", eventID);
          dispatch(
            addToCart({
              serviceType: "tenthouse",
              eventID: eventID,
              providerID: providerid,
            })
          );
          console.log("Response from addTentToCartAPI:", response);
          setMessage({
            text: "Tenthouse service successfully added to cart",
            type: "success",
          });
          dispatch(triggerRefresh());
        }
      } catch (error) {
        console.error("Error adding tenthouse provider:", error);
        setMessage({ text: "Failed to add tenthouse service", type: "error" });
      }
    }

    if (serviceId == 9) {
      if (addnewcaterer) {
        try {
          console.log("got");
          cateringItems.forEach((item) => {
            removeCateringProvider(eventID, item.providerID, item.mapping_id);
            refreshCateringCart();
            dispatch(
              removeFromCart({
                serviceType: "catering",
                eventID,
                providerID: item.providerID,
                mapping_id: item.mapping_id,
              })
            );
          });
          setMessage({
            text: "Catering service successfully removed from cart",
            type: "success",
          });
          dispatch(triggerRefresh());
        } catch (error) {
        }
      } else {
        try {
          const items = [
            { mapping_id: services.itemId, number_of_people: quantity ? quantity : 10 },
          ];
          const response = await addCateringToCartAPI({
            event_id: eventID,
            provider_id: providerid,
            items: items,
          });
          const cartdata = {
            serviceType: "catering",
            eventID: eventID,
            providerID: providerid,
            mapping_id: services.itemId,
          };
          dispatch(addToCart(cartdata));
          setMessage({
            text: "Catering service successfully added to cart",
            type: "success",
          });
          dispatch(triggerRefresh());
        } catch (error) {
          console.log("error for adding catering to cart", error);
          setMessage({
            text: `Failed to ${alreadyAdded ? "remove" : "add"} service: ${error.message || "Unknown error"
              }`,
            type: "error",
          });
        }
      }
    }
    navigate("/cart");
    window.scrollTo({ top: 0 });
  };

  const handleRemove = async () => {
    if (serviceId == 7) {
      if (alreadyAdded) {
        try {
          console.log(cartId);
          await deletePriestFromCartAPI(cartId);
          dispatch(removePreistByEventId({ eventID }));
          setMessage({
            text: "Priest successfully removed from cart",
            type: "success",
          });
          dispatch(triggerRefresh());
          console.log("Removed priest from cart successfully");
        } catch (error) {
          console.error(
            "Failed to remove priest from cart:",
            error.message,
            cartId,
            eventID
          );
        }
      }
    }
    if (serviceId == 8) {
      if (alreadyAdded) {
        try {
          await deleteTentCartItemAPI(eventID, providerid);
          dispatch(removeTenthouseByEventId({ eventID: eventID }));
          setMessage({
            text: "Tenthouse service successfully removed from cart",
            type: "success",
          });
          dispatch(triggerRefresh());
        } catch (error) {
          console.log("error while removing from cart", error);
        }
      }
    }
    if (serviceId == 9) {
      try {
        removeCateringProvider(eventID, providerid, services.itemId);
        refreshCateringCart();
        dispatch(
          removeFromCart({
            serviceType: "catering",
            eventID,
            providerID: providerid,
            mapping_id: services.itemId,
          })
        );
        setMessage({
          text: "Catering service successfully removed from cart",
          type: "success",
        });
        dispatch(triggerRefresh());
      } catch (error) {
        console.log("error while deleting in cart", error);
      }
    }
  };

  const handleMainClick = async () => {
    if ((serviceId == 7 || serviceId == 8) && checkalreadyAdded) {
      if (isChecked) {
        setpaidcheckdialog(true);
      } else {
        setAlertMessage(true);
      }
    } else if (serviceId == 9) {
      if (isChecked) {
        setpaidcheckdialog(true);
      } else {
        if (checkalreadyAdded) {
          console.log("start1 checkalreadyAdded", checkalreadyAdded);
          handleClick();
        } else {
          const providerExists = cateringItems.some(
            (item) => item.providerID === providerid
          );
          console.log("got to check allItemsInCart", cateringItems);
          if (providerExists || cateringItems.length == 0) {
            handleClick();
          } else if (!providerExists) {
            setAlertMessage(true);
          }
        }
      }
    } else {
      handleClick();
    }
  };

  const ServiceButton = ({ serviceId, alreadyAdded, handleRemove, handleMainClick }) => {
    if (serviceId === "7") {
      return alreadyAdded ? (
        <AddToCartButton
          label="Added"
          icon="pi pi-check"
          className="added_button_forcart"
          onClick={handleRemove}
          fullWidth={true}
          style={{
            background: 'linear-gradient(180deg, #b8e8f6 0%, #6cd0eb 100%)',
            border: 'none',
            borderRadius: '24px',
            color: '#1e293b',
            fontWeight: '600',
            fontSize: '14px',
            height: '44px',
            width: '100%',
            transition: 'all 0.3s ease',
            boxShadow: '0px 2px 8px rgba(12, 192, 223, 0.2)',
            cursor: 'pointer',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: '8px'
          }}
          hoverStyle={{
            background: 'linear-gradient(180deg, #a5deed 0%, #54c1dd 100%)',
            border: 'none',
            borderRadius: '24px',
            color: '#1e293b',
            fontWeight: '600',
            fontSize: '14px',
            height: '44px',
            width: '100%',
            transition: 'all 0.3s ease',
            boxShadow: '0px 4px 12px rgba(12, 192, 223, 0.3)',
            cursor: 'pointer',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: '8px'
          }}
        />
      ) : (
        <AddToCartButton
          label="Add to cart"
          onClick={handleMainClick}
          fullWidth={true}
          style={{
            background: 'transparent',
            border: '1.5px solid var(--primary-blue-color)',
            borderRadius: '24px',
            color: 'var(--primary-blue-color)',
            fontWeight: '600',
            fontSize: '14px',
            height: '44px',
            width: '100%',
            transition: 'all 0.3s ease',
            boxShadow: 'none',
            cursor: 'pointer',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: '8px'
          }}
          hoverStyle={{
            background: 'rgba(12, 192, 223, 0.08)',
            border: '1.5px solid var(--primary-blue-color)',
            borderRadius: '24px',
            color: 'var(--primary-blue-color)',
            fontWeight: '600',
            fontSize: '14px',
            height: '44px',
            width: '100%',
            transition: 'all 0.3s ease',
            boxShadow: '0 4px 8px rgba(12, 192, 223, 0.15)',
            cursor: 'pointer',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: '8px'
          }}
        />
      );
    }
    if (serviceId === "8" || serviceId === "9") {
      return alreadyAdded ? (
        <AddToCartButton
          label="Remove"
          icon="pi pi-trash"
          className="remove_button_forcart"
          onClick={handleRemove}
        />
      ) : (
        <AddToCartButton label="Add to Cart" onClick={handleMainClick} />
      );
    }
    return null;
  };

  const [SeeMoredialog, setSeeMoredialog] = useState(false);
  const handleseemore_button = () => {
    if (Number(serviceId) == 9) setSeeMoredialog(true);
  };

  const addPackageToCart = async (packageId, packageData) => {
    try {
      const response = await addPriestPackageToCartAPI({
        event_id: eventID,
        priest_id: providerid,
        service_id,
        package_id: packageId,
      });
      console.log("Added priest with package:", response);
      dispatch(
        addToCart({
          serviceType: "preist",
          eventID,
          providerID: providerid,
          service_id,
          package_id: packageId,
          price: packageData.price,
          discountprice: packageData.offeredPrice,
          discountvalidupto: packageData.validTill,
          quantity: 1,
          is_checked_out: false,
        })
      );
      setMessage({
        text: "Package added to cart",
        type: "success",
      });
      dispatch(triggerRefresh());
      navigate("/cart");
    } catch (error) {
      console.error("Error adding package to cart:", error);
      setMessage({
        text: "Failed to add package to cart",
        type: "error",
      });
    }
  };

  const [alertMessage, setAlertMessage] = useState(false);
  const [paidcheckdialog, setpaidcheckdialog] = useState(false);
  const [packageToAdd, setPackageToAdd] = useState(null);

  const handleOk = async () => {
    if (serviceId == 7) {
      if (packageToAdd) {
        await addPackageToCart(packageToAdd.packageId, packageToAdd.packageData);
        setPackageToAdd(null);
      } else {
        await handleClick();
      }
      setAlertMessage(false);
    }
    if (serviceId == 8) {
      await handleClick();
      setAlertMessage(false);
    }
    if (serviceId == 9) {
      if (checkalreadyAdded) {
        await handleClick();
        setAlertMessage(false);
      } else {
        if (cateringItems && cateringItems.length > 0) {
          try {
            console.log("Removing existing catering items...");
            cateringItems.forEach((item) => {
              removeCateringProvider(eventID, item.providerID, item.mapping_id);
              refreshCateringCart();
              dispatch(
                removeFromCart({
                  serviceType: "catering",
                  eventID,
                  providerID: item.providerID,
                  mapping_id: item.mapping_id,
                })
              );
            });
            setMessage({
              text: "Catering service successfully removed from cart",
              type: "success",
            });
            dispatch(triggerRefresh());
          } catch (error) {
            console.error("Error removing catering items:", error);
          }
        }
        await handleClick();
        setAlertMessage(false);
      }
    }
    setAlertMessage(false);
  };

  useEffect(() => {
    if (message.text) {
      const timer = setTimeout(() => {
        setMessage({ text: "", type: "" });
      }, 2000);
      return () => clearTimeout(timer);
    }
  }, [message]);

  const handleCancel = () => {
    setAlertMessage(false);
  };

  const footer = (
    <div>
      <Button
        label="Cancel"
        icon="pi pi-times"
        className="p-button-text"
        onClick={handleCancel}
      />
      <Button label="OK" icon="pi pi-check" autoFocus onClick={handleOk} />
    </div>
  );

  const paidfooter = (
    <div>
      <div>
        <Button
          label="Cancel"
          icon="pi pi-times"
          className="p-button-text"
          onClick={() => setpaidcheckdialog(false)}
        />
        <Button
          label="Myorders"
          icon="pi pi-check"
          autoFocus
          onClick={() => navigate(`/myorder?eventId=${eventID}`)}
        />
      </div>
    </div>
  );

  // Venue Pricing Card Component
  const VenuePricingCard = ({ option, type }) => {
    const price = option.price || 0;
    const hasDiscount = hasValidDiscount(option);
    const displayPrice = hasDiscount ? option.discountPrice : price;
    const savings = hasDiscount ? price - option.discountPrice : 0;

    const getBadgeClass = () => {
      switch (type) {
        case 'per_hour': return 'per-hour';
        case 'per_day': return 'per-day';
        case 'per_person': return 'per-person';
        default: return '';
      }
    };

    const getBadgeLabel = () => {
      switch (type) {
        case 'per_hour': return 'Per Hour';
        case 'per_day': return 'Per Day';
        case 'per_person': return 'Per Person';
        default: return type;
      }
    };

    return (
      <div className="venue-pricing-card">
        <div className="venue-pricing-header">
          <span className={`venue-pricing-badge ${getBadgeClass()}`}>
            {getBadgeLabel()}
          </span>
          {hasDiscount && (
            <span className="venue-savings-badge">
              Save ₹{savings.toFixed(0)}
            </span>
          )}
        </div>
        <div className="venue-pricing-amount">
          <span className="currency-symbol">₹</span>
          <span className="price-value">{displayPrice.toFixed(0)}</span>
          <span className="price-unit">/{type === 'per_hour' ? 'hr' : type === 'per_day' ? 'day' : 'person'}</span>
        </div>
        {hasDiscount && option.discountValidUpto && (
          <div className="venue-pricing-discount-info">
            <span className="original-price">₹{price.toFixed(0)}</span>
            <TimerIcon className="timer-icon" />
            <span className="valid-till">
              Till {new Date(option.discountValidUpto).toLocaleDateString('en-IN', { day: '2-digit', month: 'short' })}
            </span>
          </div>
        )}
      </div>
    );
  };

  // VENUE RENDER (serviceId === 10)
  if (Number(serviceId) === 10) {
    const providerFullName = providerFirstName || providerLastName
      ? `${providerFirstName || ''} ${providerLastName || ''}`.trim()
      : '';

    const availableSections = sections || [];
    const displayRules = rules?.slice(0, 2) || [];
    const hasMoreRules = rules?.length > 2;

    return (
      <>
        <AppointmentButton providerId={appointmentProviderId} providerName={name} eventId={event.id} eventName={event.eventTitle} source="venue" contextId={providerid} />
        <Dialog
          header="Confirmation"
          visible={alertMessage}
          style={{ width: "30vw" }}
          footer={footer}
          onHide={() => setAlertMessage(false)}
          closable={false}
        >
          {alertMessage && (
            <p>You need to remove the existing provider. Do you want to remove?</p>
          )}
        </Dialog>
        <Dialog
          header="Alert"
          visible={paidcheckdialog}
          style={{ width: "30vw" }}
          onHide={() => setpaidcheckdialog(false)}
          closable={false}
          footer={paidfooter}
        >
          <p>You have already Paid for this service for this event. You can only have one provider.</p>
        </Dialog>

        <div className="venue-provider-card">
          {/* Dealer Info Section */}
          <div className="venue-dealer-info">
            <div className="venue-avatar">
              {primaryImage?.fileId ? (
                <img
                  src={`${config.API_BASE_URL || process.env.REACT_APP_API_BASE_URL}/gallery/download/${primaryImage.fileId}`}
                  alt={name}
                  className="venue-avatar-img"
                  onError={(e) => {
                    e.target.src = "/assets/images/rent-venue-logo.png";
                  }}
                />
              ) : (
                <img
                  src="/assets/images/rent-venue-logo.png"
                  alt="Venue"
                  className="venue-avatar-img"
                />
              )}
            </div>
            <div className="venue-details">
              <div className="venue-rating-row">
                <div className="venue-rating-tag">
                  <StarIcon className="star-icon" />
                  <span className="rating-value">{rating.toFixed(1)}</span>
                </div>
                {providerFullName && (
                  <>
                    <span className="rating-divider">·</span>
                    <span className="provider-name">by {providerFullName}</span>
                  </>
                )}
              </div>
              <h3 className="venue-name">{name || ''}</h3>
              {shortAddress && (
                <div className="venue-address">
                  <LocationOnOutlinedIcon className="address-icon" />
                  <span>{shortAddress}</span>
                </div>
              )}
              {distanceInMeter != null && distanceInMeter > 0 && (
                <div className="venue-distance">
                  <RouteOutlinedIcon className="distance-icon" />
                  <span>{(distanceInMeter / 1000).toFixed(1)} km away</span>
                </div>
              )}
            </div>
          </div>

          {/* Venue Rules Section */}
          {displayRules.length > 0 && (
            <div className="venue-rules-container">
              <div className="venue-rules-header">
                <InfoOutlinedIcon className="rules-icon" />
                <span className="rules-title">Venue Rules</span>
              </div>
              {displayRules.map((rule, idx) => (
                <div key={idx} className="venue-rule-item">
                  <CircleIcon className="rule-bullet" />
                  <div className="rule-content">
                    <span className="rule-name">{rule.name}</span>
                    {rule.description && (
                      <span className="rule-description">{rule.description}</span>
                    )}
                  </div>
                </div>
              ))}
              {hasMoreRules && <span className="rules-more">...</span>}
            </div>
          )}

          {/* Available Spaces Section */}
          {availableSections.length > 0 && (
            <div className="venue-spaces-section">
              <div className="venue-spaces-header">
                <span className="spaces-title">Available Spaces</span>
                <span className="spaces-count">{availableSections.length} available</span>
              </div>

              {availableSections.map((section) => {
                const isSelected = selectedSpaceId === section.id;
                const isExpanded = expandedSpaces[section.id] || false;
                const pricingTypes = section.pricingTypes || [];
                const hasPricingOptions = section.pricingOptions && section.pricingOptions.length > 0;

                return (
                  <div
                    key={section.id}
                    className={`venue-space-card ${isSelected ? 'selected' : ''}`}
                    onClick={() => onSpaceSelected && onSpaceSelected(section.id)}
                  >
                    <div className="space-card-header">
                      <div className="space-selector">
                        {isSelected ? (
                          <CheckCircleIcon className="radio-selected" />
                        ) : (
                          <RadioButtonUncheckedIcon className="radio-unselected" />
                        )}
                        <span className="space-name">{section.name}</span>
                      </div>
                      <div className="space-actions">
                        {section.isRecommended && (
                          <span className="recommended-badge">Recommended</span>
                        )}
                        {hasPricingOptions && (
                          <button
                            className="expand-toggle"
                            onClick={(e) => {
                              e.stopPropagation();
                              toggleSpaceExpansion(section.id);
                            }}
                          >
                            {isExpanded ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
                          </button>
                        )}
                      </div>
                    </div>

                    <div className="space-details">
                      <div className="space-detail-item">
                        <SquareFootIcon className="detail-icon" />
                        <span>
                          {section.areaSqft ? `${parseFloat(section.areaSqft).toFixed(0)} sqft` : 'N/A'}
                        </span>
                      </div>
                      <div className="space-detail-item">
                        <PeopleIcon className="detail-icon" />
                        <span>
                          {section.minCapacity}-{section.maxCapacity} guests
                        </span>
                      </div>
                    </div>

                    {/* Features */}
                    {section.features && section.features.length > 0 && (
                      <div className="space-features">
                        {section.features.slice(0, 3).map((feature, idx) => (
                          <span key={idx} className="feature-tag">
                            {feature.name}
                          </span>
                        ))}
                      </div>
                    )}

                    {/* Compact pricing summary (always visible) */}
                    <div className="space-pricing-summary">
                      {hasPricingOptions ? (
                        <div className="pricing-summary-text">
                          <span className="currency-symbol">₹</span>
                          <span className="starting-price-value">{getStartingPrice(section.pricingOptions).toFixed(0)}</span>
                          <span className="starting-price-label"> starting</span>
                        </div>
                      ) : section.startingPrice != null && (
                        <div className="pricing-summary-text">
                          <span className="currency-symbol">₹</span>
                          <span className="starting-price-value">{section.startingPrice.toFixed(0)}</span>
                          <span className="starting-price-label"> starting</span>
                        </div>
                      )}
                    </div>

                    {/* Expanded Pricing Options */}
                    {isExpanded && hasPricingOptions && (
                      <div className="space-pricing-container">
                        <div className="pricing-label">
                          <span className="currency-symbol">₹</span> Pricing Options
                        </div>
                        <div className="pricing-grid">
                          {section.pricingOptions.map((option, idx) => {
                            switch (option.type) {
                              case 'per_hour':
                                return <VenuePricingCard key={idx} option={option} type="per_hour" />;
                              case 'per_day':
                                return <VenuePricingCard key={idx} option={option} type="per_day" />;
                              case 'per_person':
                                return (
                                  <div key={idx} className="per-person-pricing-wrapper">
                                    <VenuePricingCard option={option} type="per_person" />

                                    {/* Food Options */}
                                    {option.menuMappings && option.menuMappings.length > 0 && (
                                      <div className="venue-food-options">
                                        <div className="venue-food-header">
                                          <RestaurantIcon className="food-icon" />
                                          <span className="food-label">Food Options</span>
                                          {option.foodIncluded && (
                                            <span className="included-badge">Included</span>
                                          )}
                                        </div>
                                        {option.menuMappings.slice(0, 3).map((food, fidx) => (
                                          <div key={fidx} className="venue-food-item">
                                            <div className="food-item-header">
                                              <span className={`food-type-dot ${food.menu?.type === 'veg' ? 'veg' : 'non-veg'}`} />
                                              <span className="food-name">{food.menu?.name || ''}</span>
                                              <span className="food-price">₹{food.menu?.price?.toFixed(0) || 0}</span>
                                            </div>
                                          </div>
                                        ))}
                                      </div>
                                    )}

                                    {/* Drink Options */}
                                    {option.drinkOptions && option.drinkOptions.length > 0 && (
                                      <div className="venue-drink-options">
                                        <div className="venue-drink-header">
                                          <LocalBarIcon className="drink-icon" />
                                          <span className="drink-label">Drink Options</span>
                                          <span className="available-badge">Available</span>
                                        </div>
                                        {option.drinkOptions.slice(0, 2).map((drink, didx) => {
                                          const drinkTypeLabels = {
                                            'open_bar': 'Open Bar',
                                            'limited': 'Limited',
                                            'budget_based': 'Budget'
                                          };
                                          const drinkTypeLabel = drinkTypeLabels[drink.drinkType] || '';

                                          return (
                                            <div key={didx} className="venue-drink-item">
                                              <div className="drink-item-header">
                                                <div className="drink-info">
                                                  <span className="drink-name">{drink.name}</span>
                                                  <span className="drink-type">{drinkTypeLabel}</span>
                                                </div>
                                                <span className="drink-price">₹{drink.pricePerPerson?.toFixed(0) || 0}</span>
                                              </div>
                                            </div>
                                          );
                                        })}
                                      </div>
                                    )}

                                    {/* Outside Food */}
                                    {option.outsideFoodAllowed && (
                                      <div className="venue-outside-food">
                                        <FastfoodIcon className="outside-food-icon" />
                                        <span className="outside-food-label">Outside Food</span>
                                        <span className="outside-food-price">
                                          Charges: ₹{(option.price || 0).toFixed(0)}/person
                                        </span>
                                      </div>
                                    )}
                                  </div>
                                );
                              default:
                                return null;
                            }
                          })}
                        </div>
                      </div>
                    )}

                    {/* Book Space Button for this specific space */}
                    <button
                      className={`book-space-button ${!isSelected ? 'disabled' : ''}`}
                      onClick={(e) => {
                        e.stopPropagation();
                        if (isSelected) {
                          if (onBookNow) {
                            onBookNow(section.id);
                          } else {
                            navigate(`/venue-booking/${providerid}?eventId=${eventID}&spaceId=${section.id}`, {
                              state: {
                                venueId: null,
                                eventDetails: event,
                              }
                            });
                          }
                        }
                      }}
                      disabled={!isSelected}
                    >
                      {isSelected ? 'Book Selected Space' : 'Select this space to book'}
                    </button>
                  </div>
                );
              })}
            </div>
          )}
        </div>
      </>
    );
  }

  // REST OF THE EXISTING CODE FOR OTHER SERVICE TYPES (7, 8, 9)
  return (
    <>
      <AppointmentButton providerId={providerid} providerName={name} eventId={event.id} eventName={event.eventTitle} source="event-provider" contextId={serviceId} />
      <Dialog
        header="Confirmation"
        visible={alertMessage}
        style={{ width: "30vw" }}
        footer={footer}
        onHide={() => setAlertMessage(false)}
        closable={false}
      >
        {alertMessage && (
          <>
            {Number(serviceId) === 7 && (
              <p>
                You need to remove the existing priest. Do you want to remove?
              </p>
            )}
            {Number(serviceId) === 8 && (
              <p>
                You need to remove the existing tent provider. Do you want to
                remove?
              </p>
            )}
            {Number(serviceId) == 9 && (
              <p>
                You need to remove the existing catering provider. Do you want to
                remove from cart?
              </p>
            )}
          </>
        )}
      </Dialog>
      <Dialog
        header="Alert"
        visible={paidcheckdialog}
        style={{ width: "30vw" }}
        onHide={() => setpaidcheckdialog(false)}
        closable={false}
        footer={paidfooter}
      >
        <>
          {Number(serviceId) === 7 && (
            <p>
              You have already Paid for priest for this event you can only have one priest
            </p>
          )}
          {Number(serviceId) === 8 && (
            <p>
              You have already Paid for tentprovider for this event you can only have one tentprovider
            </p>
          )}
          {Number(serviceId) === 9 && (
            <p>
              You have already Paid for catering Provider for this event you can only have one catering provider
            </p>
          )}
        </>
      </Dialog>

      {
        <div className={`card-container-services ${Number(serviceId) === 7 ? "card-container-priest" : ""}`}>
          {message.text && (
            <div className={`alert alert-${message.type}`}>{message.text}</div>
          )}

          <div key={key} className={`event-service-data w-full ${Number(serviceId) === 7 ? "priest-card-inner" : ""}`}>
            {Number(serviceId) === 7 ? (
              <>
                <div className="priest-card-layout">
                  <div className="priest-avatar-container">
                    <img src={poojari} alt={name} className="priest-avatar-img" />
                  </div>
                  <div className="priest-details-container">
                    <div className="priest-rating-exp-row">
                      <span className="priest-rating-badge">
                        <i className="pi pi-star-fill" style={{ color: '#2b8a3e', fontSize: '13px' }}></i>
                        <span className="rating-value">4.1</span>
                      </span>
                      <span className="priest-exp-text">
                        5.0+ yr Exp
                      </span>
                    </div>
                    
                    <h3 className="priest-name-text">{name || ""}</h3>
                    
                    <div className="priest-distance-location">
                      {!isNaN(distance) && typeof distance === "number"
                        ? `${(distance / 10000).toFixed(1)} km`
                        : "0.0 km"}
                      {" • "}
                      {getDistrictOrCity(address)}
                    </div>

                    <div className="priest-price-text">
                      ₹{discount ?? price}
                    </div>
                  </div>
                </div>

                {packagePriceInfo.hasPackages && packagePriceInfo.availableForCurrentEvent && (
                  <div className="priest-packages-overlay-container">
                    <PackageOverlay
                      packages={packages}
                      eventName={eventname}
                      eventID={eventID}
                      providerName={name}
                      providerid={providerid}
                      onAddPackageToCart={handleAddPackageToCart}
                      alreadyAdded={alreadyAdded}
                    />
                  </div>
                )}

                <div className="priest-card-button-row">
                  <ServiceButton
                    serviceId={serviceId}
                    alreadyAdded={alreadyAdded}
                    handleRemove={handleRemove}
                    handleMainClick={handleMainClick}
                  />
                </div>
              </>
            ) : (
              <>
                <div className="top-container">
                  <div style={{ display: "flex", gap: "20px" }}>
                    <div className="event-service-headder">
                      <div className="event-service-headtop">
                        <h3>{name || ""}</h3>
                      </div>
                      <div style={{ gap: "4px" }}>
                        {address?.length > 0 && (
                          <div className="info-item">
                            <LocationOnOutlinedIcon className="service-icon" />
                            {address.length > 30
                              ? `${address.substring(0, 30)}***`
                              : address}
                          </div>
                        )}
                        <div
                          style={{
                            display: "flex",
                            flexDirection: "column",
                            gap: "8px",
                          }}
                        >
                          {!isNaN(distance) && (
                            <div className="info-item">
                              <RouteOutlinedIcon className="service-icon" />
                              {typeof distance === "number"
                                ? `${(distance / 10000).toFixed(2)} km`
                                : ""}
                            </div>
                          )}{" "}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="service-container">
                    <div className="service-data">
                      {Number(serviceId) == 9 && <span className="Total-Amount">
                        ₹{discount ?? price} / Plate
                      </span>}
                      <div className={Number(serviceId) === 7 ? "rating-container-priest" : "rating-container"}>
                        <span className="Rating-Text">
                          {Number(serviceId) === 7 ? (
                            <i className="pi pi-star-fill" style={{ color: '#2b8a3e', fontSize: '13px', marginRight: '4px' }}></i>
                          ) : (
                            <img
                              style={{
                                verticalAlign: "middle",
                                marginRight: "6px",
                                width: "15px",
                                height: "15px",
                              }}
                              src={Events_performed}
                              alt="Events performed"
                            />
                          )}
                          {" "}
                          <span className="data-info">4.5</span>
                        </span>
                      </div>
                    </div>
                  </div>
                </div>

                {serviceId == 9 && (
                  <div className="catering-courses">
                    <div className="coutse-items">
                      <div className="course-header">Items</div>
                      <div className="course-items-by-list">
                        {catering_main.length > 0 ? (
                          <>
                            {catering_main.slice(0, 4).map((item, key) => (
                              <div key={key} className="menu-item-row">
                                <span className="catering-menu-item-name">
                                  {item.itemName}
                                </span>
                                <span className="catering-menu-item-quantity">
                                  ({item.qty})
                                </span>
                              </div>
                            ))}
                            {catering_main.length > 4 && (
                              <div style={{ textAlign: "left", width: "100%" }}>
                                <a
                                  href="#"
                                  onClick={(e) => {
                                    e.preventDefault();
                                    e.stopPropagation();
                                    handleSeeMore("Main", catering_main);
                                  }}
                                  className="see-more-link"
                                >
                                  View More Items ({catering_main.length - 4} more)
                                </a>
                              </div>
                            )}
                          </>
                        ) : (
                          <div style={{ textAlign: "left" }}>
                            No items available
                          </div>
                        )}
                      </div>
                    </div>

                    {/* Dialog Component - Rendered outside the conditional flow but controlled by state */}
                    <MenuDialog
                      isOpen={isDialogOpen}
                      onClose={handleCloseDialog}
                      label={selectedMenu?.label || "Main Items"}
                      mainItems={selectedMenu?.items || []}
                    />
                  </div>
                )}

                {Number(serviceId) == 8 && (
                  <div className="catering-courses">
                    <div className="coutse-items">
                      <div className="course-header">Items</div>
                      <div className="course-items-by-list">
                        {Itemnames_withquantity?.map((item, idx) => (
                          <div key={idx}>
                            {item.itemName} ({item.quantity})
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>
                )}

                <div className="final-price-list">
                  {Number(serviceId) == 9 ? (
                    <div className="price-details">
                      <div className="add-to-cart">
                        <ServiceButton
                          serviceId={serviceId}
                          alreadyAdded={alreadyAdded}
                          handleRemove={handleRemove}
                          handleMainClick={handleMainClick}
                        />
                      </div>
                    </div>
                  ) : Number(serviceId) == 8 ? (
                    <div className="price-details">
                      <div style={{ display: "flex", fontWeight: "600", gap: "6px" }}>
                        <span>Total Amount ₹{discount ?? price}</span>
                        {discount && (
                          <span
                            style={{ marginLeft: "0px", fontWeight: "400" }}
                            className={discount ? "line-through" : ""}
                          >
                            ₹{price}
                          </span>
                        )}
                      </div>
                      <div className="add-to-cart">
                        <ServiceButton
                          serviceId={serviceId}
                          alreadyAdded={alreadyAdded}
                          handleRemove={handleRemove}
                          handleMainClick={handleMainClick}
                        />
                      </div>
                    </div>
                  ) : null}
                </div>
              </>
            )}
          </div>
        </div>
      }
    </>
  );
}

const getDistrictOrCity = (addr) => {
  if (!addr) return "Local area";
  const parts = addr.split(",");
  if (parts.length >= 2) {
    const cleanParts = parts.map(p => p.trim()).filter(Boolean);
    const filteredParts = cleanParts.filter(p => !p.toLowerCase().includes("india"));
    if (filteredParts.length > 0) {
      return filteredParts[filteredParts.length - 1];
    }
  }
  return addr;
};

export default ProviderListingCard;

function formatIncludedItems(raw, opts = {}) {
  const { maxVisible = 6 } = opts;
  if (!Array.isArray(raw) || raw.length === 0) return null;
  const qtyMap = new Map();
  for (const it of raw) {
    const name = (it?.itemName || it?.item_name || "").toString().trim();
    if (!name) continue;
    const qNum = Number(it?.qty);
    const hasValidQty = Number.isFinite(qNum) && qNum > 0;
    if (!qtyMap.has(name)) {
      qtyMap.set(name, { qtySum: hasValidQty ? qNum : null });
    } else {
      const entry = qtyMap.get(name);
      if (hasValidQty) {
        entry.qtySum = (entry.qtySum ?? 0) + qNum;
      }
    }
  }
  if (qtyMap.size === 0) return null;
  const allTokens = Array.from(qtyMap.entries()).map(([name, { qtySum }]) =>
    qtySum && qtySum > 0 ? `${name} (${qtySum})` : name
  );
  const visible = allTokens.slice(0, maxVisible);
  const hiddenCount = Math.max(allTokens.length - visible.length, 0);
  const join = (arr) => {
    if (typeof Intl !== "undefined" && Intl.ListFormat) {
      return new Intl.ListFormat("en-IN", {
        style: "long",
        type: "conjunction",
      }).format(arr);
    }
    return arr.join(", ");
  };
  const text =
    hiddenCount > 0 ? `${join(visible)} +${hiddenCount} more` : join(visible);
  const fullText = join(allTokens);
  return { text, fullText, visible, hiddenCount };
}

function splitIncludedItems(raw = []) {
  if (!Array.isArray(raw) || raw.length === 0) {
    return { main: [], sides: [] };
  }
  const main = [];
  const sides = [];
  for (const it of raw) {
    const name = (it?.itemName || it?.item_name || "").toString().trim();
    if (!name) continue;
    const qNum = Number(it?.qty);
    const hasValidQty = Number.isFinite(qNum) && qNum > 0;
    if (hasValidQty) {
      main.push({ name, qty: qNum });
    } else {
      sides.push({ name });
    }
  }
  return { main, sides };
}
